@if (!checkNoHeaderRoutes()) {
  <app-global-header></app-global-header>
}

<router-outlet> </router-outlet>
<ngx-spinner bdColor="transparent" class="med_spinner" type="ball-scale-multiple">
  <div class="loading-container">
    <img src="assets/images/m-logo.svg" alt="Loading" />
  </div>
</ngx-spinner>
<p-toast class="med-toast" [preventOpenDuplicates]="true" />
